import { ReactNode } from 'react';

import { Box, CSSProperties } from '@bcp-nextgen-dx-component-factory/design-system';

export interface AppLayoutProps {
	children?: ReactNode;
	styles?: CSSProperties;
}

export const AppLayout = ({ children, styles }: AppLayoutProps) => {
	return <Box styles={{ minHeight: '100vh', flexDirection: 'column', flex: 1, ...styles }}>{children}</Box>;
};
